import React, { useEffect, useState } from "react";
import Selector from "../../../components/Selector/Selector";
import Search from "../../../components/Inputs/Search/Search";
import "./JourneysTable.css";
import CustomTable from "../../../components/CustomTable/CustomTable";
import PrimaryButton from "../../../components/Buttons/PrimaryButton/PrimaryButton";
import { SizeType } from "antd/es/config-provider/SizeContext";
import editIcon from "../../../images/_edit.svg";
import minusIcon from "../../../images/minus.svg";
import deleteIcon from "../../../images/trashpink.svg";
import documentIcon from "../../../images/document.png";
import eyeIcon from "../../../images/eye.png";
import { useDispatch, useSelector } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import ConfirmPopUp from "../../../components/PopUp/ConfirmPopUp/ConfirmPopUp";
import { Link, useNavigate } from "react-router-dom";
import { t } from "i18next";
import { DateRangeSelector } from "components/DateTimeSelectors/DateRangeSelector/DateRangeSelector";
import { PAGE_OPTIONS } from "utils/constants/selectorOptions";
import useMessage from "../../../hooks/useMessage";
import centralApi from "services/centralApi";
import { API_ENDPOINTS, ROUTES } from "utils/constants";
import { getToken } from "redux/features/app/authTokenSlice";
import { formatDate } from "helperFunctions/date";
import { DateFormatEnum,PlatformEnum} from "utils/enums";
import AccessControl from "components/HOC/AccessControl/AccessControl";
import { roleCheckTypes } from "utils/constants/constants";
import PageLayout from "layout/PageLayout/PageLayout";
import CustomBreadCrumb from "components/CustomBreadCrumb/CustomBreadCrumb";

type propTypes = {
  pageSize?: number;
  tableSize?: SizeType;
};
const JourneysTable: React.FC<propTypes> = ({ tableSize }) => {
  const navigate = useNavigate();
  const loginUser = useSelector((state: any) => state.loginUser);
  const { appId } = useSelector((state: any) => state.activeApp);
  const dispatch:any=useDispatch()
  const [pageData, setPageData] = useState({
    pageSize: PAGE_OPTIONS.DEFAULT_VALUE,
    simple: PAGE_OPTIONS.PAGINATION.simple,
  });
  const [journeysData, setJourneysData] = useState([]);
  const [journeysDataCopy, setJourneysDataCopy] = useState([]);
  const [dateRange, setDateRange] = useState<any>(null);
  const { showError, showSuccess } = useMessage();
  const [platform, setPlatform] = useState(PlatformEnum.ALL);


  const [loading, setLoading] = useState(false);
  async function getJourneysListData() {
    const apiKey = loginUser.data.api_key;
    try {
      if (apiKey && appId) {
        const params= {
          app_id: appId,
          api_key: apiKey,
          d: dateRange,
        }
        setLoading(true);
        const data: any = await centralApi("GET",API_ENDPOINTS.GET_USER_JOURNEY_LIST_URL,null,params);
        setJourneysData(data);
        filterData();
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  useEffect(() => {
    getJourneysListData();
  }, [loginUser]);
  // FILTER THE DATA
  const filterData = (search = "") => {
    const searchRegex = new RegExp(search, "i");
    setJourneysDataCopy(
      journeysData?.filter((jur: any) => {
        const isWithinDateRange =
          (!dateRange?.startDate_C ||
            jur.modifiedOn >= dateRange.startDate_C) &&
          (!dateRange?.endDate_C || jur.modifiedOn <= dateRange.endDate_C);

        // Check if the search term matches
        const isSearchMatch = searchRegex.test(jur.journeyName);
        const isPlatformMatch =
        platform == PlatformEnum.ALL || jur.platform == platform;
        // Return true if both conditions are met
        return isWithinDateRange && isSearchMatch && isPlatformMatch;


      })
    );
  };

  //on  popup confirm delete journey
  const journeyDeleteConfirm = async (id: string) => {
    try {
      const params={
        app_id: appId,
        api_key: loginUser.data.api_key,
        id: id}
      await centralApi("GET",API_ENDPOINTS.DELETE_USER_JOURNEY_URL,null,params);
      showSuccess(t("journeyDeletedSuccessfullyLabel"));
      getJourneysListData();
    } catch (error) {
      showError(t("somethingWrongLabel"));
    }
  };
  //copy the journey
  const journeyCopyConfirm = async (id: string) => {
    try {
      const params={
        app_id: appId,
        api_key: loginUser.data.api_key,
        id: id,
      }
      await dispatch(getToken()).unwrap();
      await centralApi("GET",API_ENDPOINTS.COPY_USER_JOURNEY_URL,null,params);
      showSuccess(t("copiedMsg"));
      //get updated data
      getJourneysListData();
    } catch (error) {
      showError(t("somethingWrongLabel"));
    }
  };
  //handle date range change
  const handleDateRange = (dateRangeData: any) => {
    setDateRange(dateRangeData);
  };
  useEffect(() => {
    filterData();
  }, [dateRange, journeysData,platform]);
 
  const columns: any = [
    {
      title: t("journeyNameLabel"),
      dataIndex: "journeyName",
    },
    {
      title: t("journeyDescriptionLabel"),
      dataIndex: "journeyDescription",
    },
    {
      title: t("startEventLabel"),
      dataIndex: "startEvent",
    },
    {
      title: t("endEventLabel"),
      dataIndex: "endEvent",
    },
    {
      title: t("createdOnLabel"),
      dataIndex: "createdOn",
      render: (createdOn: number) => {
        return createdOn && <div>{formatDate(createdOn * 1000, DateFormatEnum.ABBREVIATED_MONTH_TIME)}</div>;
      },
    },
    {
      title: t("createdByLabel"),
      dataIndex: "createdBy",
    },
    {
      title: t("modifiedOnLabel"),
      dataIndex: "modifiedOn",
      render: (createdOn: number,{modifiedBy}:{modifiedBy:string | undefined}) => {
        return modifiedBy && createdOn && <div>{formatDate(createdOn * 1000, DateFormatEnum.ABBREVIATED_MONTH_TIME)}</div>;
      },
    },
    {
      title: t("modifiedByLabel"),
      dataIndex: "modifiedBy",
    },
    {
      title: t("actionLabel"),
      dataIndex: "_id",
      width: "180px",
      className: "item-align",
      render: (id: string) => {
    
        return (
          <span className="d-flex justify-content-between campaign-action-btns">
            {" "}
            <AccessControl accessControl={{role:[roleCheckTypes.Checker ,roleCheckTypes.Maker]}}>
            <ConfirmPopUp
              title={t("copyJourneyMsg")}
              onConfirm={journeyCopyConfirm}
              id={id}
              icon={documentIcon}
              placement="leftTop"
            >
              <PrimaryButton title={t("copyLabel")} className="action-btn mx-1">
                <img
                  src={documentIcon}
                  alt={"document_icon"}
                ></img>
              </PrimaryButton>
            </ConfirmPopUp>
            <PrimaryButton
              title={t("editLabel")}
              className="action-btn mx-1"
              onClick={() => navigate("create", { state: { id } })}
            >
              <img src={editIcon} alt={"edit_icon"}></img>
            </PrimaryButton>{" "}
            <ConfirmPopUp
              title={t("deleteJourneyMsg")}
              onConfirm={journeyDeleteConfirm}
              id={id}
              icon={deleteIcon}
              placement="leftTop"
            >
              <PrimaryButton
                title={t("deleteLabel")}
                className="action-btn mx-1"
              >
                <img src={minusIcon} alt={"minus_icon"}></img>
              </PrimaryButton>
            </ConfirmPopUp>
            </AccessControl>
            <Link to={`/dashboard/journeys/${id}`}>
              <PrimaryButton title={t("viewLabel")} className="action-btn mx-1">
                <img src={eyeIcon} alt={"eye_icon"}></img>
              </PrimaryButton>
            </Link>
          </span>
        );
      },
    },
  ];
 
  return (
    <PageLayout
    title={`${t("journeysLabel")}`}
    className="journey-table-container"
    topLeftItem={
      <CustomBreadCrumb
      items={[
        {
          title: <Link to={ROUTES.DASHBOARD_JOURNEYS}>{t("journeysLabel")}</Link>,
        }]}></CustomBreadCrumb>
    }
    topRightItem={
      <div className="d-flex gap-2 justify-content-end">
        <div>
            <strong className="me-2">{t("platformLabel")}</strong>
            <Selector
              onChange={(value) => {
                setPlatform(value);
              }}
              size="middle"
              defaultValue={platform}
              className="platform-selector"
              options={[
                {
                  value: PlatformEnum.ALL,
                  label: t("allLabel"),
                },
                {
                  value: PlatformEnum.ANDROID,
                  label: t("androidLabel"),
                },
                {
                  value: PlatformEnum.IOS,
                  label: t("iosLabel"),
                },
                {
                  value: PlatformEnum.WEB,
                  label: t("webLabel"),
                },
              ]}
            />
      </div>
      <div>
      <strong>{t("periodLabel")} </strong>
      <DateRangeSelector
        onDateChange={handleDateRange}
        disableRange={{ range: 1, rangeType: "year" }}
        disableType="year"
        numDaysToShow={30} // Example value
      />
      </div>
    </div>
    }
    >
        <div className="d-flex flex-row w-100">
          <div className="w-100 d-flex h-100 ">
            <Search
              placeholder={`${t("searchLabel")}`}
              onChange={(e: any) => filterData(e.target.value)}
              size="middle"
              className="table-search"
            />
            <Selector
              onChange={(value) => {
                setPageData({ ...pageData, pageSize: value });
              }}
              className="page-selector"
              size="middle"
              defaultValue={PAGE_OPTIONS.DEFAULT_VALUE}
              options={PAGE_OPTIONS.DATA}
            />
          </div>
          <AccessControl accessControl={{role:[roleCheckTypes.Checker ,roleCheckTypes.Maker]}}>
          <div className="">
            <PrimaryButton
              type="primary"
              onClick={() => {
                navigate(ROUTES.DASHBOARD_JOURNEYS_CREATE);
              }}
            >
              <PlusOutlined />
              <span className="mx-1">{t("journeyLabel")}</span>
            </PrimaryButton>
          </div>
          </AccessControl>
        </div>

        <CustomTable
          columns={columns}
          totalEntries={journeysData?.length}
          dataSource={journeysDataCopy.map((jur: any) => ({
            ...jur,
            key: jur._id,
          }))}
          size={tableSize || PAGE_OPTIONS.DEFAULT_SIZE}
          loading={loading}
          pagination={{ pageSize: pageData.pageSize, simple: false }}
          scroll={{ x: 1400 }}
        />
    </PageLayout>
  );
};

export default JourneysTable;

